// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5a9c2409","160":"ab8bd56c","208":"9e3cf0b4","293":"df2ce8bd","453":"8d9d37d5","516":"4bcafe14","519":"b1efc869","917":"2ee07d76","924":"2a07eeb5","946":"f1e2a31d"}[chunkId] + ".chunk.js";
};